import { Checkbox, styled } from "@mui/material";
import { getColors } from "utils";
import { BpRadioCheckedIcon, BpRadioIcon } from "./Radio";

const BpIcon = styled("span")(({ theme, isRadio }) => {
  const colors = getColors(theme, "");
  const { light } = colors;
  return {
    borderRadius: 6,
    width: 20,
    height: 20,
    // padding:1,
    border: "1px solid #DBDDE0",
    // boxShadow:
    //   "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "&:hover": {
      backgroundColor: light,
    },
    "input:disabled ~ &": {
      // boxShadow: "none",
      background: "#F4F4F5",
      ...theme.applyStyles("dark", {
        background: "rgba(57,75,89,.5)",
      }),
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
      ...theme.applyStyles("dark", {
        backgroundColor: "#30404d",
      }),
    },

    ...theme.applyStyles("dark", {
      boxShadow: "0 0 0 1px rgb(16 22 26 / 40%)",
      backgroundColor: "#394b59",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))",
    }),
  };
});

const BpCheckedIcon = styled(BpIcon)(({ theme }) => {
  const colors = getColors(theme, "");
  const { dark, darker } = colors;
  return {
    backgroundColor: dark,
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&::before": {
      display: "block",
      width: 16,
      height: 16,
      margin: 1,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:disabled ~ &": {
      "&::before": {
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
          " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
          "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23D1D3D6'/%3E%3C/svg%3E\")",
      },
    },
    "input:hover ~ &": {
      backgroundColor: darker,
      ...theme.applyStyles("dark", {
        backgroundColor: "#30404d",
      }),
    },
  };
});

const CheckBoxUI = styled(Checkbox)(({ theme }) => ({
  "& input": {
    padding: 0,
    width: 20,
    height: 20,
    margin: "auto",
    top: "auto",
    left: "auto",
  },

  "&:hover": { backgroundColor: "transparent" },
  // "&:disable": { backgroundColor: "transparent" },
  "& .anticon.anticon-minus-square.icon": {
    borderRadius: 6,
    "& svg": {
      borderRadius: 6,
      width: 20,
      height: 20,
    },
  },
}));

// Inspired by blueprintjs
const BpCheckbox = ({ checked, value, isRadio = false, inputProps, slotProps, ...props }) => {
  return (
    <CheckBoxUI
      disableRipple
      color="default"
      checkedIcon={isRadio ? <BpRadioCheckedIcon /> : <BpCheckedIcon />}
      icon={isRadio ? <BpRadioIcon /> : <BpIcon />}
      checked={checked ?? value}
      {...props}
      slotProps={{
        ...slotProps,
        input: { "aria-label": props.id, ...inputProps, ...slotProps?.input },
      }}
    />
  );
};

export default BpCheckbox;
